<template>
  <div id="product">
<!--    <button @click="goToTest">跳转</button>-->
    <div class="title">{{equipName}}</div>
    <!--分割-->
    <div class="br"></div>
    <div class="product-list">
      <div class="product-list-item">
        <!--单个的数据-->
        <div class="product-list-item-details" v-for="(item,index) in productList" :key="index">
          <div class="img-box" @click="goToDetail(item.sort)">
            <a href="javascript:void(0)">
              <div class="img">
                <img v-if="item.fileLib" :src="item.fileLib.path" width="160" height="160" style="margin: 0 auto"/>
                <img v-else :src="defaultPicPath" width="160" height="160" style="margin: 0 auto"/>
              </div>
            </a>
            <!-- <div style="z-index: 1001; position: absolute; top: 3px; left: 25px; color: black; font-size: 10px;" class="ios">
              {{item.name}}</div> -->
          </div>
          <div class="img-content">
            <div class="img-content-title">
              <a href="javascript:void(0)">{{item.name}}</a>
            </div>
            <div class="price" v-if="free == 0">
              <span class="ng-binding">¥{{item.price}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {productList,getAppId,getEquipInfo} from "@/api/productApi"
import {checkSource} from "../utils/productUtil";
import {getUrlParam} from "@/utils/commonUtil";

export default {
  name: 'ProductDtu',
  data () {
    return {
      defaultPicPath:require('../assets/no_pic.png'),
      dtuNo: '',
      productList:[],
      free:0,
      equipName:''
    }
  },
  methods:{
    goToTest(){
    },
    getEquip(){
      let that = this;
      getEquipInfo({dtuNo:that.dtuNo}).then(res=>{
        if(res.code === 200){
            that.equipName = res.data.name;
        }
      })
    },
    // 获取饮品列表
    getProductList(){

      if(this.dtuNo){
        productList({dtuNo:this.dtuNo}).then(res=>{
        // 如果获取成功，赋值给数组，进行展示
        if(res.code === 200){
          res.data.forEach(element=>{
            this.productList.push(element)

          })
          console.log(this.productList)
        }
      })
      }else{
        // 提示报错
        alert('获取设备编号失败')
        return
      }
    },
    // 跳转
    goToDetail(sort){
      // console.log(id)
      // console.log(this.dtuNo)
      // sessionStorage.setItem('sort',this.sort)
      this.$router.push({name:'ProductDetail',query:{dtuNo:this.dtuNo,free:this.free,sort:sort}})
    },
    getAppId(param){
      getAppId(param).then(res=>{
        // if(res.data.wxAppId!=null && res.data.wxAppId!=''){
        //   sessionStorage.setItem("wxAppId",res.data.wxAppId)
        // }else if(res.data.aliAppId !=null && res.data.aliAppId!=''){
        //   sessionStorage.setItem("aliAppId",res.data.aliAppId)
        // }
      })
    }
  },
  mounted() {
    this.free = Number(this.$route.query.free);
    this.dtuNo = this.$route.query.dtuNo
    this.getEquip()
    this.getProductList()
    // 将设备编号和来源都存起来,没存对象，还没想好要不要存
    let source = checkSource()
    // let source  = 2
    //sessionStorage.setItem('source',source)
  }
}
</script>

<style lang="less">
  #product{
    width: 100vw;
    height: 100vh;
    background-color: #F5F5F5;
    min-width: 320px;
    max-width: 800px;
    margin: auto;
    -webkit-tap-highlight-color: transparent;
    .title{
      z-index: 999;
      background-color: #ffffff;
      display: block;
      height: 2.6rem;
      line-height:2.6rem
    };
    .br{
      height: .4em;
      width: 100%;
      background-color: #F0EFF4;
    }
    .product-list{
      overflow: auto;
      -webkit-box-flex: 1;
      // background-color: #fff;
      .product-list-item{
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        flex-direction: row;
        -webkit-flex-wrap: wrap;
        .product-list-item-details{
          background-color: #ffffff;
          border-bottom: 1px #E6E6E6 solid;
          width: 49%;
          .img-box{
            width: 100%;
            position: relative;
            margin-bottom: .5em;
            a{
              background: 0 0;
              color: #4183C4;
              text-decoration: none;
              .img{
                text-align: center;
              }
            }
          }
          .img-content{
            font-size: 14px;
            text-align: left;
            padding: .6em;
            .img-content-title{
              a{
                background: 0 0;
                color: #000000;
                text-decoration: none;
                display: block;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                margin-bottom: .2em;
              }
            }
            .price{
              margin-top: .3rem;
              font-size: .8em;
              color: #fd4648;
              margin-bottom: 0;
              .ng-binding{
                font-size: 16px;
              }
            }
          }
        }
        .product-list-item-details:nth-child(odd) {
          border-right: 1px solid #E6E6E6;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductDtu.vue